(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Webapp", [], factory);
	else if(typeof exports === 'object')
		exports["Webapp"] = factory();
	else
		root["Webapp"] = factory();
})(self, () => {
return 